import { Eyebrow } from "@/components/BrandGeometry";
import { Reveal } from "@/components/Reveal";

// Shared header band for interior pages (forms, legal).
export default function PageHeader({ eyebrow, title, intro }) {
  return (
    <section className="border-b border-line bg-cream">
      <div className="mx-auto max-w-4xl px-6 pb-16 pt-16 sm:px-10 sm:pt-24 lg:px-16">
        <Reveal>
          {eyebrow && <Eyebrow className="mb-6">{eyebrow}</Eyebrow>}
          <h1 className="font-display text-4xl font-medium leading-[1.05] tracking-tight text-navy sm:text-5xl md:text-6xl">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-body sm:text-lg">
              {intro}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
